import { FC, PropsWithChildren } from 'react';
import { useGetUserQuery } from '../api';
import { FeatureFlagContext } from '../contexts';

export const FeatureFlagContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { data: user } = useGetUserQuery();
  return (
    <FeatureFlagContext.Provider
      value={{ featureFlags: user?.org?.featureFlags }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
